(function () {
  'use strict';

  /* @ngdoc object
   * @name serverNotFound
   * @description
   *
   */
  angular
    .module('neo.serverNotFound', [
      'ui.router'
    ]);
}());
